module.exports = __webpack_public_path__ + "static/media/trans-r.51be344b.png";